import React from 'react'
import Grid from '@mui/material/Grid';
import { Button, Container } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Image1 from '../assets/images/Banner1.png';
import Image2 from '../assets/images/Banner2.png';
import Image3 from '../assets/images/Banner3.png';
import Image33 from '../assets/images/Banner33.png';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import ShieldIcon from '@mui/icons-material/Shield';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import { BsLightbulbFill } from "react-icons/bs";
import 'react-toastify/dist/ReactToastify.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { RiSecurePaymentFill } from "react-icons/ri";
import { TbMessage2Cog } from 'react-icons/tb';
import { LuMonitorStop } from 'react-icons/lu';
import { SiAdguard } from 'react-icons/si';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

function Home() {
  const { theme } = useTheme();

  return (
    <div>
      <section className='top-home-banner-section'>
        <Container maxWidth="lg">
          <Grid container
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}>
            <Grid item xs={12} sm={12} md={12} lg={10}>
              <h1 className='b-top-text-1'>Empower Your Digital Assets — Secure, Simple, and Fast Crypto Wallet</h1>
              <p className='b-top-text-2'>Explore 100+ Blockchains and Thousands of dApps Effortlessly with NVXO Wallet</p>
              <div style={{ textAlign: "center" }}>
                <Link to='https://play.google.com/store/apps/details?id=com.nvwallet.wallet' target='_blank'>
                  <Button className='b-top-text-btn-1' sx={{ mt: 2 }}>Join Wallet</Button>
                </Link>
              </div>
            </Grid>
          </Grid>
        </Container>


        <Container maxWidth="lg" sx={{ marginTop: "40px" }}>
          <Grid container
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid item xs={8} sm={8} md={7} lg={6}>
              <LazyLoadImage src={Image1} alt='Image1'
                style={{
                  width: "100%",
                  height: "100%",
                }} />
            </Grid>
          </Grid>
        </Container>
      </section>

      <section className='top-home-banner-section-2'>
        <Container maxWidth="lg">
          <Grid container
            className='top-home-banner-section-2-2'
            spacing={4}
            sx={{
              justifyContent: "center",
            }}>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <div style={{ textAlign: "center" }}>
                <FingerprintIcon className="b-top-icon-2" />
              </div>
              <Card className="top-home-sec-card-1">
                <CardContent>
                  <h5>Private</h5>
                  <p>Your data stays yours; we never store addresses, balances, or personal information.</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <div style={{ textAlign: "center" }}>
                <ShieldIcon className="b-top-icon-2" />
              </div>
              <Card className="top-home-sec-card-1">
                <CardContent>
                  <h5>Trust</h5>
                  <p>Fully encrypted and transparent, with no personal data collection.</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <div style={{ textAlign: "center" }}>
                <DocumentScannerIcon className="b-top-icon-2" />
              </div>
              <Card className="top-home-sec-card-1">
                <CardContent>
                  <h5>Control</h5>
                  <p>With self-custody, you own your assets and have full access to your crypto at all times.</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <div style={{ textAlign: "center" }}>
                <BsLightbulbFill className="b-top-icon-2" />
              </div>
              <Card className="top-home-sec-card-1">
                <CardContent>
                  <h5>Intuition</h5>
                  <p>Designed for everyone, from beginners to experts, start using crypto in minutes.</p>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </section>

      <section className='top-home-banner-section-3'>
        <Container maxWidth="lg">
          <Grid container
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
            spacing={4}
          >
            <Grid item xs={10} sm={8} md={6} lg={6}>
              <LazyLoadImage
                src={Image2}
                alt="Image2"
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <h5>Chat & Pay: Secure, Instant, and Convenient</h5>
              <p>The NVXO Wallet App's special Chat & Pay feature allows users to chat and transact effortlessly within a single platform. Whether you're sending funds to a friend or discussing financial plans, our integrated chat function ensures a seamless and secure experience. Enjoy real-time messaging with end-to-end encryption, allowing you to communicate and transfer funds confidently.</p>
            </Grid>
          </Grid>
        </Container>
      </section>

      <section className='top-home-banner-section-4'>
        <Container maxWidth="xl">
          <Grid container
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
            spacing={4}
          >
            <Grid item xs={12} sm={12} md={6} lg={4}
              sx={{
                order: {
                  xs: 2,
                  sm: 2,
                  md: 2,
                  lg: 1
                }
              }}
            >
              <div className='section-4-card-1'>
                <div className='section-4-card-icon-1-top'>
                  <RiSecurePaymentFill className='section-4-card-icon-1' />
                </div>
                <h5>Instant Payments</h5>
                <p>Effortlessly send and receive funds directly within the chat, making transactions as simple as sending a message. Whether you're paying a friend, our integrated payment feature ensures that your money moves as fast as your conversation. No need to switch apps or deal with complicated processes—just type, tap, and transact. With instant payment confirmations, you can be sure your funds reach the recipient securely and immediately.</p>
              </div>
              <div className='section-4-card-1 section-4-card-1-1'>
                <div className='section-4-card-icon-1-top'>
                  <TbMessage2Cog className='section-4-card-icon-1' />
                </div>
                <h5>Secure Messaging</h5>
                <p>Communicate with confidence using our secure messaging feature, where all conversations are protected by end-to-end encryption. This advanced security measure ensures that your messages remain private and can only be read by you and the intended recipient, preventing unauthorized access. Whether you’re discussing financial details or general topics, your data is fully safeguarded, providing peace of mind that your personal and financial information is kept confidential and secure at all times.</p>
              </div>
            </Grid>

            <Grid item xs={8} sm={8} md={8} lg={4}
              sx={{
                order: {
                  xs: 1,
                  sm: 1,
                  md: 1,
                  lg: 2
                }
              }}
            >
              <LazyLoadImage
                src={theme == "light" ? Image33 : Image3}
                alt="Image3"
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={4}
              sx={{
                order: {
                  xs: 3,
                  sm: 3,
                  md: 3,
                  lg: 3
                }
              }}
            >
              <div className='section-4-card-1 sec-4-right' >
                <div className='section-4-card-icon-1-top'>
                  <SiAdguard className='section-4-card-icon-1' />
                </div>
                <h5>Smart Notifications</h5>
                <p>Stay informed with real-time alerts for your financial activity. Receive instant notifications whenever payments are made or received, ensuring you’re always up-to-date with your account status. so you never miss your important financial event. Keep your finances on track effortlessly with our smart notification system.</p>
              </div>
              <div className='section-4-card-1 sec-4-right section-4-card-1-1'>
                <div className='section-4-card-icon-1-top'>
                  <LuMonitorStop className='section-4-card-icon-1' />
                </div>
                <h5>User-friendly Experience</h5>
                <p>Our NVXO wallet app offers an intuitive interface designed for effortless navigation and interaction. You'll find it easy to manage your transactions and communicate with contacts without the distraction of unnecessary features. While we focus on core functionalities, such as payment requests and transaction details, our streamlined design enhances usability and ensures you can quickly access what you need. Enjoy a seamless experience where managing your finances and chatting with friends is simple and efficient, all in one place.</p>
              </div>
            </Grid>
          </Grid>
        </Container>
      </section>

    </div>
  )
}

export default Home
